import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexibleSelectionTileComponent } from '@woolworthsnz/form';
import { FulfilmentWindowSummarySlot } from '@woolworthsnz/trader-api';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { displayDateAtServer } from '../../helpers';
import { NgFor } from '@angular/common';

dayjs.extend(customParseFormat);

@Component({
	selector: 'fulfilment-flexible-delivery-slot-multiple-selection',
	templateUrl: './fulfilment-flexible-delivery-slot-multiple-selection.component.html',
	styleUrls: ['./fulfilment-flexible-delivery-slot-multiple-selection.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, FlexibleSelectionTileComponent, NgFor],
})
export class FulfilmentFlexibleDeliverySlotMultipleSelectionComponent {
	@Input() slots?: FulfilmentWindowSummarySlot[];
	@Input() controlName: string;
	@Input() date: string;
	@Input() formGroup: FormGroup;
	@Output() timeslotSelectedEvent = new EventEmitter<FulfilmentWindowSummarySlot>();

	selectedSlot: FulfilmentWindowSummarySlot;

	getLabel(slotId: number): string {
		const slot = this.slots?.find((x) => x.id === slotId);
		return `${displayDateAtServer(slot?.start)?.format('h:mma')} - ${displayDateAtServer(slot?.end)?.format(
			'h:mma'
		)}`;
	}

	selectSlot(slot: FulfilmentWindowSummarySlot): void {
		this.selectedSlot = slot;
		this.timeslotSelectedEvent.emit(slot);
	}
}
